import snsWebSdk from '@sumsub/websdk';

/**
 * @param accessToken - access token that you generated on the backend in Step 2
 * @param applicantEmail - applicant email (not required)
 * @param applicantPhone - applicant phone, if available (not required)
 * @param customI18nMessages - customized locale messages for current session (not required)
 */
export function launchWebSdk({
    token,
    onComplete,
    onPending,
    onError,
    onGetAccessToken
}: {
    token: string
    onComplete: () => Promise<void>
    onPending: () => Promise<void>
    onError: (error: any) => Promise<void>
    onGetAccessToken: () => Promise<string>
}) {
    let snsWebSdkInstance = snsWebSdk.init(
            token,
            // token update callback, must return Promise
            // Access token expired
            // get a new one and pass it to the callback to re-initiate the WebSDK
            onGetAccessToken
        )
        .withOptions({ addViewportTag: false, adaptIframeHeight: true})
        // see below what kind of messages WebSDK generates
        /**
         * This idCheck.onApplicantStatusChanged also have
         * reviewResult?: {
         *     reviewAnswer: 'GREEN' | 'RED'  
         * }
         */
        .on('idCheck.onApplicantStatusChanged', (finalState) => {
            const status = finalState.reviewStatus.toUpperCase()
            if (status === 'COMPLETED') {
                onComplete()
            } else {
                onPending()
            }
        })
        .on('idCheck.onError', (error) => {
            onError(error)
        })
        .build();

    // you are ready to go:
    // just launch the WebSDK by providing the container element for it
    snsWebSdkInstance.launch('#sumsub-websdk-container')
}
